import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostoNomina = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Automotriz', 'Servicios logísticos', 'Construcción', 'Retail', 'Alimentos', 'Salud/Farmacéutica', 'Manufactura'];
  const data2023 = [45, 27, 25, 15, 11, 4, 1];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map(label => data2023[allLabels.indexOf(label)]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: dataValues2023,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 35,
        borderRadius: 4,
        categoryPercentage: 0.6,
        barPercentage: 1.0,
        minBarLength: 8, // 👈 asegura que el 1% sea visible
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 40,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#1F3D58',
        anchor: 'end',
        align: 'right',
        offset: 6,
        clip: false,
        formatter: (value) => `${value}%`,
        font: {
          weight: 'bold',
          size: 14,
        },
      }      
      
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje %',
        },
        stacked: false,
        min: 0,
        max: 50,
      },
      y: {
        title: {
          display: true,
          text: 'Industria',
        },
        beginAtZero: true,
        stacked: false,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        onBarClick([industry]);
      }
    },
  };

  const infoContent = {
    Analisis: 'El sector Automotriz destaca con el mayor porcentaje (45%), lo que refleja una alta dependencia de capital humano en sus operaciones logísticas. Le siguen Servicios logísticos (27%) y Construcción (25%), mientras que sectores como Manufactura (1%) y Salud/Farmacéuticas (4%) muestran una proporción significativamente menor.',
    formula: '𝐶𝑜𝑠𝑡𝑜 𝑑𝑒 𝑁ó𝑚𝑖𝑛𝑎 𝐿𝑜𝑔í𝑠𝑡𝑖𝑐𝑎 (%) = (𝐶𝑜𝑠𝑡𝑜 𝑑𝑒 𝑁𝑜𝑚𝑖𝑛𝑎 𝐿𝑜𝑔í𝑠𝑡𝑖𝑐𝑎 / 𝑣𝑒𝑛𝑡𝑎 𝑏𝑟𝑢𝑡𝑎 )𝑥 100',
    description: 'La gráfica presenta el porcentaje de la nómina logística sobre el costo total operativo en cada industria durante 2023.',
  };

  return (
    <div style={{ width: '100%', height: '555px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CostoNomina;
